export default __webpack_public_path__ + "static/media/split-promotional-header-background-mobile.4740ceb0.svg";